import { Fragment, useCallback, useEffect } from "react";
import logoFull from "components/icons/logo_full.svg";
import { loadDisableAds } from "utils/storage";
import { AdUnitsKeys, units } from "./config/units";
import classes from "./AdUnit.module.scss";
import useWindowDimensions from "../../hooks/useWindowDimension";

const RETRY_LIMIT = 5;
const TIMEOUT = 1000;

export enum AdUnitTypeEnum {
  MOBILE="Mobile",
  DESKTOP="Desktop"
}

interface AdUnitProps {
  name: AdUnitsKeys;
  type: AdUnitTypeEnum;
}

const AdUnit = ({ name, type }: AdUnitProps) => {
  const isDesktop = useWindowDimensions();

  const code = units[name];
  const isDisableAds = loadDisableAds() === "yes";
  const id = code.display ?? `sp_${code.sid}`;

  const addCode = useCallback((iteration: number) => {
    if (iteration > RETRY_LIMIT) {
      return;
    }

    if (!window?.goCtrl?.add) {
      console.debug("[ads] goCtrl instance not found");
      setTimeout(() => {
        addCode(iteration + 1);
      }, TIMEOUT);
      return;
    }

    const { style, ...goCtrlCode } = code;
    goCtrlCode.display = id;

    console.debug("[ads] goCtrl is ready.");

    window.goCtrl.add(goCtrlCode);
  }, [code, id]);

  useEffect(() => {
    if (isDisableAds) {
      return;
    }

    addCode(0);
  }, [isDisableAds, addCode]);

  const width = code.style?.width || "100%";
  const height = code.style?.height || "100%";

  return (
    <Fragment>
      { ((isDesktop && type === AdUnitTypeEnum.DESKTOP) || (!isDesktop && type === AdUnitTypeEnum.MOBILE)) && (
        <div className={classes.wrapper} style={code.style} data-name={name}>
          {
            isDisableAds ? (
              <div className={classes.placeholder}>
                <div className={classes.background}/>
                <div
                  className={classes.content}
                  style={{
                    transform: width >= height ? "" : "rotate(90deg)",
                    width: width >= height ? width : height,
                    height: width >= height ? height : width,
                    marginLeft: width >= height ? 0 : width,
                  }}
                >
                  <div><img src={logoFull} width={282} height={52} alt="" /></div>
                  <div>advertisement: {name}</div>
                  <div>id: {code.sid}</div>
                </div>
              </div>
            ) : null
          }
          <div className={classes.ad} id={id} />
        </div>
      )}
    </Fragment>
  );
};

export default AdUnit;
